import { render, staticRenderFns } from "./ChoiceGrid.vue?vue&type=template&id=c5c8a574&scoped=true&"
import script from "./ChoiceGrid.vue?vue&type=script&lang=js&"
export * from "./ChoiceGrid.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceGrid.vue?vue&type=style&index=0&id=c5c8a574&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c8a574",
  null
  
)

export default component.exports